// extracted by mini-css-extract-plugin
export default {"root":"DeleteModal_root__glkyH","container":"DeleteModal_container__TF0By"};